import styled from "@emotion/styled";
import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import ErrorBoundaryComponent from "@/shared/components/error-boundary";
import Loaders from "@/shared/components/loader";
import { catchServerError } from "@/shared/helpers/catch-server-error";
import { sleep } from "@/shared/helpers/sleep.helper";
import UseSnackbar from "@/shared/hooks/use-snackbar.hook";
import useCookieSessionManager from "@rf-hooks/useCookieSessionManager";
import { useLogoutUserMutation } from "@/shared/services/qrtk/auth/user-auth.qrtk";
import { useLoggedUser } from "@/shared/store/auth";
import { PATH } from "@/shared/models/const/path";

function LogoutModule() {
  const [userLogoutM] = useLogoutUserMutation();
  const { clearUser } = useLoggedUser();
  const { removeSessionFromCookie } = useCookieSessionManager();
  const showMessage = UseSnackbar();
  const navigate = useNavigate();
  const Logout = () => {
    clearUser();
    removeSessionFromCookie(); // remove user from store only user for maxcore v1
    sleep(0.5).then(() => {
      navigate(PATH.PUBLIC.AUTH.LOGIN);
    });
  };

  const singOutUser = () => {
    userLogoutM(null)
      .unwrap()
      .then(() => {})
      .catch(err => showMessage(catchServerError(err)))
      .finally(() => Logout());
  };
  useEffect(() => {
    singOutUser();
  }, []);

  return (
    <ErrorBoundaryComponent suspendComponent={<Loaders />}>
      <Routes>
        <Route path="" element={<Loaders />} />
      </Routes>
    </ErrorBoundaryComponent>
  );
}

export default LogoutModule;

const Spinner = styled.div`
  width: 100%;
  height: calc(100vh - 75px);
  display: flex;
  justify-content: center;
  align-items: center;
`;
